import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import useButtonColor from '../useButtonColor';
import usePaymentLogos from '../usePaymentLogos';
import config from '../../../config';
import { useFormContext } from 'react-hook-form';
import { DonateButtonFormData } from '../../../../types/givingCheckoutForm';

const StandardButtonPreview: FunctionComponent = () => {
  const { t } = useTranslation();

  const { buttonColor, textColor } = useButtonColor();
  const { watch } = useFormContext<DonateButtonFormData>();
  const includePaymentLogos = watch('includePaymentLogos');
  const { paymentTypeLogosFilename, paymentTypesList } = usePaymentLogos();

  const buttonWrapperStyles: React.CSSProperties = {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 296,
    minWidth: 256,
    margin: '12px auto',
    textAlign: 'center',
  };

  const buttonStyles: React.CSSProperties = {
    cursor: 'pointer',
    backgroundColor: buttonColor,
    borderRadius: 4,
    lineHeight: '48px',
    display: 'inline-block',
    color: textColor,
    padding: '0 24px',
    fontSize: '18px',
    textDecoration: 'none',
    width: '100%',
    textAlign: 'center',
    fontFamily: 'sans-serif',
    boxSizing: 'border-box',
  };

  const paymentLogoStyles: React.CSSProperties = {
    marginTop: 12,
  };

  return (
    <div aria-hidden className="standardDonateButton__preview">
      <div style={buttonWrapperStyles}>
        <div style={buttonStyles}>
          {t('donateButton.standardButton.buttonText')}
        </div>
        {includePaymentLogos && (
          <img
            style={paymentLogoStyles}
            src={`${config.jg_cdn_url}buttons/${paymentTypeLogosFilename}`}
            alt={paymentTypesList}
          />
        )}
      </div>
    </div>
  );
};

export default StandardButtonPreview;
